import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';
import FullPageSection from './FullPageSection';
import { usePortfolio } from '../hooks/usePortfolio';
import './PortfolioBrutalist.css';

const PortfolioBrutalist = () => {
    const { projects, loading, error } = usePortfolio();
    const [selectedProject, setSelectedProject] = useState(null);

    const openModal = (project) => {
        setSelectedProject(project);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedProject(null);
        document.body.style.overflow = 'auto';
    };

    if (loading) {
        return (
            <FullPageSection id="portfolio" className="portfolio-brutalist">
                <div className="portfolio-loading">
                    <div className="loading-brutalist"></div>
                </div>
            </FullPageSection>
        );
    }

    if (error || projects.length === 0) {
        return null;
    }

    return (
        <>
            <FullPageSection id="portfolio" className="portfolio-brutalist">
                <div className="portfolio-brutalist-grid">
                    {projects.map((project) => (
                        <div
                            key={project.behance_id}
                            className="portfolio-item"
                            onClick={() => openModal(project)}
                        >
                            <div className="portfolio-item-image">
                                {project.cover_image_url ? (
                                    <img
                                        src={project.cover_image_url}
                                        alt={project.name}
                                        loading="lazy"
                                    />
                                ) : (
                                    <div className="portfolio-item-placeholder">MAPDESIGN</div>
                                )}
                            </div>
                            <div className="portfolio-item-overlay">
                                <h3 className="portfolio-item-title">{project.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </FullPageSection>

            {/* Modal */}
            {selectedProject && (
                <div className="modal-brutalist" onClick={closeModal}>
                    <button className="modal-brutalist-close" onClick={closeModal}>
                        <X size={40} strokeWidth={3} />
                    </button>

                    <div className="modal-brutalist-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-brutalist-image">
                            <img
                                src={selectedProject.cover_image_url}
                                alt={selectedProject.name}
                            />
                        </div>

                        <div className="modal-brutalist-info">
                            <h1 className="modal-brutalist-title">{selectedProject.name}</h1>

                            {selectedProject.fields && selectedProject.fields.length > 0 && (
                                <div className="modal-brutalist-tags">
                                    {selectedProject.fields.map((field, idx) => (
                                        <span key={idx}>{field}</span>
                                    ))}
                                </div>
                            )}

                            <div className="modal-brutalist-description">
                                <p>{selectedProject.description || 'Projeto criativo e inovador.'}</p>
                            </div>

                            {selectedProject.url && (
                                <a
                                    href={selectedProject.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="modal-brutalist-link"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    VIEW ON BEHANCE <ArrowRight size={24} strokeWidth={3} />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PortfolioBrutalist;
